import React, { useEffect, useState } from 'react';
import { HashLink as Link } from 'react-router-hash-link';

const SinglePriceV2 = ({ price }) => {
    const [isClosed, setIsClosed] = useState(false);

    useEffect(() => {
        const checkClosingDate = async () => {
            try {
                const res = await fetch('https://eventscons.com/eventbackendnew/api/closing/date');
                const response = await res.json();
                const actualData = Array.isArray(response) ? response : response.data;
                
                const regData = actualData?.find(item => item.type === "registration");
                
                if (regData) {
                    const closingDate = new Date(regData.closing_date);
                    const now = new Date();
                    
                    // Agar aaj ki date closing date se zyada hai toh close kar do
                    if (now > closingDate) {
                        setIsClosed(true);
                    }
                }
            } catch (err) {
                console.error("Error checking date:", err);
            }
        };

        checkClosingDate();
    }, []);

    return (
        <>
            <div className="inner-box">
                <div className="price-box">
                    <h4 className="price">${price?.price}</h4>
                </div>
                <div className="title">{price?.description}</div>

                {!localStorage.getItem("token") && (
                    <div className="btn-box">
                        {isClosed ? (
                            // Disabled state ka button
                            <button 
                                className="theme-btn btn-style-one" 
                                disabled 
                                style={{ backgroundColor: '#ccc', cursor: 'not-allowed', borderColor: '#ccc' }}
                            >
                                <span className="btn-title">Registration Closed</span>
                            </button>
                        ) : (
                            // Active state ka button
                            <Link to="/registertype" className="theme-btn btn-style-one">
                                <span className="btn-title">Register</span>
                            </Link>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};

export default SinglePriceV2;